<div class="pp">

  <!-- The product first: a tidy desktop in its collections, on the stage, with the intro on its band. -->
  <div class="pp-stage">
    <header class="pp-wrap pp-intro">
      <div class="pp-intro-main">
        <span class="pp-platform">
          <img src="./assets/third-parties/logo/macos-apps.webp" alt="">
          macOS App
        </span>
        <h1 class="pp-name">
          <img src="./assets/product-lines/tools/macos-tidy-desktop.png" alt="" class="pp-icon" width="72" height="72">
          <span>Tidy Desktop: AI Organizer</span>
        </h1>
        <p class="pp-pitch">The AI desktop organizer for Mac: your files in tidy collections, sorted by what they're for with Apple's on-device AI</p>
        <ul class="pp-facts" aria-label="At a glance">
          <li *ngFor="let f of facts">{{ f }}</li>
        </ul>
      </div>

      <div class="pp-act">
        <div class="pp-cta" [class.cp-cta-stack]="sellsHere">
          <!-- sold on the site too (2026-10-14), as the Color Picker page: Add to cart with the price beside it, the
               Mac App Store (Coming Soon until the listing is public) on the row under it -->
          <ng-container *ngIf="sellsHere; else appStoreOnly">
            <div class="cp-buy-row">
              <button type="button" class="codigrate-button" (click)="addToCart()"><p>Add to cart</p></button>
              <span class="cp-offer" *ngIf="priceLabel">
                <span class="cp-offer-amount">{{ priceLabel }}</span>
                <span class="cp-offer-note">One-time purchase</span>
              </span>
            </div>
            <a class="codigrate-button cp-btn-neutral" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall( $event )"><p>Install from the Mac App Store</p></a>
            <span class="codigrate-button cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the Mac App Store</p></span>
          </ng-container>
          <ng-template #appStoreOnly>
            <a class="codigrate-button" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall( $event )"><p>Install from the Mac App Store</p></a>
            <span class="codigrate-button cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the Mac App Store</p></span>
            <a class="codigrate-button cp-btn-neutral" routerLink="/themes"><p>Browse the Themes</p></a>
          </ng-template>
        </div>
      </div>
    </header>

    <!-- a tidy desktop, raw (owner 2026-10-10); it opens in the lightbox with the others -->
    <div class="pp-wrap">
      <button class="pp-shot" type="button" *ngIf="heroShot as shot; else heroFigure" (click)="openLightbox( shot )" [attr.aria-label]="'Enlarge: ' + shot.name">
        <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
      </button>
      <ng-template #heroFigure>
        <figure class="pp-shot">
          <img [src]="hero.src" [alt]="hero.alt" [width]="hero.width" [height]="hero.height" loading="eager" decoding="async">
        </figure>
      </ng-template>
    </div>
  </div>

  <div class="pp-wrap">

    <!-- The first thing it does, under the stage: one desktop, before on the left and after on the right -->
    <section class="dt-feature dt-feature-intro" [attr.data-layout]="intro.layout" [attr.data-key]="intro.key" aria-labelledby="dt-feature-intro">
      <div class="dt-feature-words">
        <h2 class="dt-headline" id="dt-feature-intro"><span class="dt-accent">{{ intro.accent }}</span> {{ intro.rest }}</h2>
        <p class="dt-text">{{ intro.description }}</p>
      </div>
      <div class="dt-scenes">
        <button *ngFor="let sc of intro.scenes; trackBy: trackScene" type="button" class="dt-scene" (click)="enlarge( sc )" [attr.aria-label]="'Enlarge: ' + sc.name">
          <img [src]="src( sc )" [alt]="sc.alt" [width]="sc.width" [height]="sc.height" loading="lazy" decoding="async">
          <span class="dt-scene-label" *ngIf="sc.label">{{ sc.label }}</span>
        </button>
      </div>
    </section>

    <!-- One section per thing the app does, one under the other (owner 2026-10-10: as the Dock Town
         page): the App Store picture's headline and its words, centred, and under them its raw
         screens as pictures of their own, each opening in the lightbox; a single screen in a box
         of one height for every section, the four themes two by two. -->
    <section class="dt-feature" *ngFor="let f of pictured; trackBy: trackFeature"
             [attr.data-layout]="f.layout" [attr.data-key]="f.key" [attr.aria-labelledby]="'dt-feature-' + f.key">
      <div class="dt-feature-words">
        <h2 class="dt-headline" [id]="'dt-feature-' + f.key"><span class="dt-accent">{{ f.accent }}</span> {{ f.rest }}</h2>
        <p class="dt-text">{{ f.description }}</p>
      </div>
      <div class="dt-scenes">
        <button *ngFor="let sc of f.scenes; trackBy: trackScene" type="button" class="dt-scene" (click)="enlarge( sc )" [attr.aria-label]="'Enlarge: ' + sc.name">
          <img [src]="src( sc )" [alt]="sc.alt" [width]="sc.width" [height]="sc.height" loading="lazy" decoding="async">
          <span class="dt-scene-label" *ngIf="sc.label">{{ sc.label }}</span>
        </button>
      </div>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">What Else It Does</h2>
      <ul class="pp-list">
        <li *ngFor="let f of features">
          <h3>{{ f.title }}</h3>
          <p>{{ f.description }}</p>
        </li>
      </ul>
    </section>

    <section class="pp-section">
      <h2 class="pp-section-title">Questions</h2>
      <div class="pp-faq">
        <details class="pp-faq-item" *ngFor="let f of faq">
          <summary>{{ f.q }}</summary>
          <p>{{ f.a }}</p>
        </details>
      </div>
    </section>

    <!-- Lightbox: the theme pages' (src/styles/page/tool-lightbox.scss). The picture over a
         frosted backdrop and one pill under it: previous, the picture's name, next, close.
         The arrow keys page through the pictures and Escape closes. -->
    <div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
      <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
        <img [src]="lightbox.large" [alt]="lightbox.alt">
      </figure>
      <!-- the pictures on either side load while this one shows, so the arrows turn at once -->
      <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
      <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
      <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
        <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( -1, $event )" aria-label="Previous screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <!-- as wide as the longest name (all are stacked in one cell), so the pill keeps its size -->
        <span class="cp-lb-seg td-lb-label">
          <span class="cp-lb-name">
            <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
            <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
          </span>
        </span>
        <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( 1, $event )" aria-label="Next screenshot">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </button>
        <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
      </div>
    </div>

    <section class="cp-closing">
      <h2 class="cp-closing-title">Tidy Up Your Desktop</h2>
      <p class="cp-closing-text">Every file stays where it is; only the way your desktop looks changes</p>
      <div class="cp-closing-buy" *ngIf="sellsHere">
        <button type="button" class="codigrate-button cp-closing-btn" (click)="addToCart()"><p>Add to cart</p></button>
        <span class="cp-offer" *ngIf="priceLabel">
          <span class="cp-offer-amount">{{ priceLabel }}</span>
          <span class="cp-offer-note">One-time purchase</span>
        </span>
      </div>
      <a class="codigrate-button cp-closing-btn" [class.cp-btn-neutral]="sellsHere" *ngIf="released" [href]="appStoreUrl" target="_blank" rel="noopener" (click)="onInstall( $event )"><p>Install from the Mac App Store</p></a>
      <!-- until the listing is public: the same Coming Soon as at the top (owner 2026-10-10: the foot of
           every app page is its store button, never another link) -->
      <span class="codigrate-button cp-closing-btn cp-btn-neutral" *ngIf="!released"><p>Coming Soon to the Mac App Store</p></span>
      <!-- the privacy policy at the foot, as on every app page (owner 2026-10-10) -->
      <p class="cp-note td-closing-note">No account, no tracking, no ads: nothing leaves your Mac.
        <a class="td-note-link" [routerLink]="URLS.plugins.macosTidyDesktopPrivacy">Read the Tidy Desktop Privacy Policy</a></p>
    </section>

  </div>

</div>
